import axiosInstances from '../utils/axiosInstances';

class PreferredLocationService {
  #dispatchQoreAxiosInstance;

  constructor() {
    this.#dispatchQoreAxiosInstance = axiosInstances({
      baseURL: process.env.REACT_APP_DISPATCH_QORE_API,
      headers: {
        'Ocp-Apim-Subscription-Key': process.env.REACT_APP_NSD_API_KEY
      },
      withCredentials: true
    });
  }

  getPreferredLocationLists() {
    return this.#dispatchQoreAxiosInstance.get('/getPreferredLocationLists');
  }
}

export default PreferredLocationService;
